export default function HubSpotAnalytics() {
  return (
    <script
      type="text/javascript"
      id="hs-script-loader"
      async
      defer
      src="//js.hs-scripts.com/46816059.js"
    />
  );
}
